import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import AuthWrapper from './AuthWrapper';

// Find the root div in index.html
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the App component into the root div.
// AuthWrapper owns the anonymous landing page vs authenticated app boundary.
root.render(
  <React.StrictMode>
    <AuthWrapper>
      <App />
    </AuthWrapper>
  </React.StrictMode>
);
